import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { CensoredLoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaLoanRequestResolver_GetCensoredLoanRequest = CensoredLoanRequestsTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetCensoredLoanRequest = z.infer<
    typeof schemaLoanRequestResolver_GetCensoredLoanRequest
>;

export type LoanRequestResolver_GetCensoredLoanRequest = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetCensoredLoanRequest
>;
